/**
 * Created by JasonChou on 16/5/2.
 */
import Vue from 'vue';
import VueResource from 'vue-resource';
import Events from './Events'
import {
  isString
} from '../utils/typeUtils'

Vue.use(VueResource);
const headers = {'x-log-apiversion':  '0.6.0', 'x-log-bodyrawsize': '2048'}

Vue.http.interceptors.push(request => {
  if (request.method === 'POST' && request.url.indexOf('log.aliyuncs.com/logstores/wuwei/track') > -1) {
    for(let k in headers) {
      request.headers.set(k, headers[k])
    }
    console.log(request.headers)
  }
})

var http = {
  loadingDelegate: null
};

const v = new Vue()

http.exec = function (options, headers = {}) {
  options.data = options.data || {};

  var method = options.method || 'get';

  let url = options.url;

  if (options.jsonp)
    url += '?_method=' + method;

  const $Message = Vue.prototype.$Message
  return Vue.http[method](url, options.data, headers).then((res) => {
    if (res.status == 404) {
      v.$Message.error('请求资源不存在');
      return Promise.resolve({})
    }
    return res;
  }).catch(function (obj) {
    if (obj.ok == false && obj.status == 401) {
      if (isString(obj.bodyText) && obj.bodyText) {
        v.$Message.error(obj.bodyText)
      } else {
        v.$Message.error('权限不足！')
      }
      window.location.href = "/#!/login"; //可以跳转.
      return
    } else if (obj.ok === false && obj.status == 500) {
      if (obj.body.msg == '您不是成员') {
        v.$Message.error("您不是该项目成员，即将返回工作台...",3000)
        setTimeout(() => {
          window.location.href = `${figureOpenUrl}d1cfc74a258bcfb7dc72c7fc4e9cb0c4`
        }, 3000);
      }else{
        let currentTime = new Date().getTime();   // 当前的时间
        let dueTime = JSON.parse(window.localStorage.getItem("editorLogInfo")).deadline   // 用户使用平台的过期时间
        if (currentTime > dueTime) {
          v.$Message.error("抱歉，您的订阅已过期，暂时不能编辑该项目，即将返回工作台...",3000)
          setTimeout(() => {
            window.location.href = `${figureOpenUrl}d1cfc74a258bcfb7dc72c7fc4e9cb0c4`
          }, 3000);
        }
        v.$Message.error(obj.body.msg || obj.body.devMsg)
      }

    }
    return obj;
  });
};

['post', 'put', 'get', 'delete'].forEach(function (method) {
  http[method] = function (options) {
    options.method = method;
    return http.exec(options);
  }
});

http.setLoadingDelegate = function (loadingDelegate) {
  this.loadingDelegate = loadingDelegate;
};


if (!Vue.prototype.$$http) {
  Vue.prototype.$$http = http;
  ['post', 'put', 'get', 'delete'].forEach(method => {
    Vue.prototype[`$$${method}`] = (url, opts) => {
      let options = {}
      options.url = url

      if (method === 'get' || method === 'delete') {
        options.data = { params: opts }
      } else {
        options.data = opts
      }

      // fix: 保证后端传过来的字段格式统一性，方便统一处理，理论上后端应统一字段
      return new Promise((resolve, reject) => {
        return http[method](options).then(res => {
          if (res.ok === false && res.status != 200) {
            // fix: 处理后端乱七八槽不统一的字段
            reject(Object.assign(res.body, {
              errcode: res.body.errcode,
              msg: res.body.msg || res.body.devMsg || ''
            }))
          } else {
            resolve(Object.assign(res.body.data || {}, {
              errcode: res.body.errcode,
              msg: res.body.msg || res.body.devMsg || ''
            }))
          }
        })
      })
    }
  })
}

if (!Vue.prototype.$bus) {
  Vue.prototype.$bus = v
}

if (!Vue.prototype.$report) {
  Vue.prototype.$report =  function(opts = {}, isSendBeacon = false) {
    if (process.env.NODE_ENV !== 'production') return
    if (!opts.aliSLS) {
      opts.aliSLS = {
        project: 'hex',
        host: 'cn-beijing.log.aliyuncs.com',
        logstore: 'wuwei'
      }
    }
    const { project, host, logstore } = opts.aliSLS
    delete opts.aliSLS
    const apiVersion = '0.6.0'
    let url = `//${project}.${host}/logstores/${logstore}/track?APIVersion=${apiVersion}`
    opts._env = process.env.NODE_ENV || 'production'
    opts._os = window.navigator.userAgent
    opts._host = window.location.hostname
    opts._type = 'editor-front'

    const logs = JSON.stringify(opts)
    opts.__topic__ = 'hex_editor'
    opts.__source__ = window.navigator.userAgent
    const parsedLogs = JSON.parse(logs)
    opts.__logs__ = [parsedLogs]
    for(let k in parsedLogs) {
      delete opts[k]
    }
    // TODO: 根据需求分类处理
    opts.__tags__ = {
      'tag1': 'Editor上报'
    }
    if (isSendBeacon) {
      // navigator.sendBeacon not support custom headers, so please isSendBeacon false
      if(typeof navigator !== 'undefined' && navigator.sendBeacon) {
        return navigator.sendBeacon(url, new Blob([JSON.stringify(opts)], {
          type: 'application/json',
        }));
      }
    } else {
      this.$$post(url, opts)
           .then(x => console.log(`[SLS Report] ${url} ${opts}`, x))
    }

  }
  // 以下是老的 report 协议
  Vue.prototype.$addBuriedUsage = function addBuriedUsage (species, menuId, menuName, titleId, titleName, selfId, selfName, projectId, appId, pageId, userId) {
    const payload = {
      species,
      menuId,
      menuName,
      titleId,
      titleName,
      selfId,
      selfName,
      projectId,
      appId,
      pageId,
      userId
    };

    const p = this.$$post('/api/statistics/buried_usage',payload)
    this.$report(payload)
    return p
  }
  Vue.prototype.$propsBuriedUsage = function propsBuriedUsage  (species, objectId, type, propsValue, parentsKeyName, parentsKeyId, projectId, appId, pageId)  {
    const data = {
      species,
      objectId,
      type,
      propsValue,
      parentsKeyName,
      parentsKeyId,
      projectId,
      appId,
      pageId
    };
    const p = this.$$post('/api/statistics/buried_setting',data)
    this.$report(Object.assign({}, data, {propsValue: JSON.stringify(propsValue)}))
    return p
  }
  Vue.prototype.$timeBuriedUsage = function timeBuriedUsage (data) {
    const p = this.$$post('/api/statistics/buried_page_time',data)
    this.$report(data)
    return p
  }

  Vue.prototype.$utilButtonTrack =  function utilButtonTrack(menuId, titleId, selfId) {
    let appId = this.$store.state.app.appInfo._id;
    let projectId = this.$store.state.project.info._id;
    let pageId = this.$store.state.page.pageInfo._id;
    let userId = this.$store.state.userInfo._id;
    this.$addBuriedUsage("function_button", menuId, "", titleId, "", selfId, "", projectId, appId,
      pageId, userId).then(res => {})
  }

  Vue.prototype.$timeTrack = function timeTrack (startTime, endTime) {
    let appId = this.$store.state.app.appInfo._id;
    let projectId = this.$store.state.project.info._id;
    let pageId = this.$store.state.page.pageInfo._id;
    let appType = localStorage.getItem("appType");
    let switchType = localStorage.getItem("switchType");
    let dirId = localStorage.getItem("dirId");
    let classify = 'page';
    let data = {
      switchType,
      classify,
      appType,
      startTime,
      endTime,
      projectId,
      appId,
      dirId,
      pageId
    };
    this.$timeBuriedUsage(data).then(res => {
      localStorage.setItem("startTime",Date.now());
    })
  }
}



export default http;



// WEBPACK FOOTER //
// ./src/libs/http.js